import observable from 'static/script/app/ui/checkout2/context/observable';

let shipping = {};

observable.on('shipping-type-selected', function(type) {
    shipping.selectedShippingType = type;
});

export default shipping;
